import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function CreateProduct({ username, onClose }) {
    const [loading, setLoading] = useState(false);
    const [MetalList, setMetalList] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        matt_id: "",
        price: "",
        tax: "",
        comment: "",
        est_id: "",
        user_transaction: username,
        color: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    //Calculate the total price with tax every time the price or tax
    useEffect(() => {
        const price = parseFloat(formData.price) || 0;
        const tax = parseFloat(formData.tax) || 0;
        const total = price + (price * (tax / 100));
        setTotalPrice(total.toFixed(2)); //rounded two decimals
    }, [formData.price, formData.tax]);

    const handleCreate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/Products/insert`, formData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate('/product-list');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Product already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <center>
                                <h4>Create Product</h4>
                            </center>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <Link className='btn btn-warning' to="/product-list" onClick={onClose}>Go Back</Link>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    {/*Name */}
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Product Name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    {/*Price */}
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="price" className="form-label">Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Price"
                                            name="price"
                                            value={formData.price}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/*Tax */}
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="tax" className="form-label">Tax (%)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Tax Percentage"
                                            name="tax"
                                            value={formData.tax}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/*Total Price (Price + Tax) */}
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="totalPrice" className="form-label">Total Price (incl. Tax)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="totalPrice"
                                            value={totalPrice}
                                            disabled
                                        />
                                    </div>

                                    {/*Comment */}
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="comment" className="form-label">Xero Item Code</label>
                                        <input
                                        type="text"
                                            className="form-control"
                                            placeholder="Enter Xero Item Code"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        ></input>
                                    </div>

                                    {/*Status */}
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="est_id" className="form-label">Status</label>
                                        <select
                                            className="form-select"
                                            name="est_id"
                                            value={formData.est_id}
                                            onChange={handleChange}
                                        >
                                            <option value="1">Activated</option>
                                            <option value="2">Disabled</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="card-header align-items-center d-flex">
                                    <div className="col-md-12">
                                        <div className="text-end">
                                            <Link className="btn btn-danger" to="/product-list" style={{ marginRight: "5px" }} onClick={onClose}>
                                                Discard changes
                                            </Link>
                                            <button className="btn btn-primary" type="submit" disabled={loading}>
                                                {loading ? "Loading..." : "Create"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateProduct;
